module.exports = __webpack_public_path__ + "assets/img/B_icon.18e32277.png";